import React from 'react';
import { Box } from 'theme-ui';

const FlexContent = ({ children, flexBasis = '1/2', width, p, sx }) => (
  <Box
    sx={{
      flexBasis,
      width,
      p,
      zIndex: [null, 1],
      ...sx,
    }}
  >
    <div>{children}</div>
  </Box>
);

export default FlexContent;
